// src/components/ReportStatusChart.tsx

const ReportStatusChart = () => {
    const data = [
      { status: 'Pending', count: 1245, color: 'bg-yellow-500' },
      { status: 'In Progress', count: 542, color: 'bg-blue-500' },
      { status: 'Resolved', count: 3891, color: 'bg-green-500' },
      { status: 'Escalated', count: 312, color: 'bg-red-500' },
    ];
  
    const total = data.reduce((sum, item) => sum + item.count, 0);
  
    return (
      <div className="bg-white rounded-xl shadow-sm p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-6">Report Status Distribution</h3>
        <div className="space-y-4">
          {data.map((item) => {
            const percentage = Math.round((item.count / total) * 100);
            
            return (
              <div key={item.status} className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm font-medium text-gray-700">{item.status}</span>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-bold text-gray-900">{item.count.toLocaleString()}</span>
                    <span className="text-xs text-gray-500">({percentage}%)</span>
                  </div>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div
                    className={`h-2 rounded-full ${item.color}`}
                    style={{ width: `${percentage}%` }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  
  export default ReportStatusChart;